export const PHONE_REGEX = /\d{6,10}$/;
export const NON_DIGITS_REGEX = /[^0-9]/g;